import { render, staticRenderFns } from "./aeroMenu.vue?vue&type=template&id=2147e080&"
import script from "./aeroMenu.vue?vue&type=script&lang=js&"
export * from "./aeroMenu.vue?vue&type=script&lang=js&"
import style0 from "./aeroMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports